import { FC, memo, useState, useEffect } from 'react';
import { OptimizelyPaywall } from './SophiIteration/OptimizelyPaywall';
import { AuthIterationType } from './types';
import { isMobile } from '@benzinga/device-utils';

export const SophiIterations: FC<AuthIterationType> = memo(({ authMode, nextUrl, placement, setShowPaywall }) => {
  const showMobile = isMobile();
  const [versionIndex, setVersionIndex] = useState<number | null>(null);

  const closePaywall = (show: boolean) => {
    if (setShowPaywall) {
      setShowPaywall(show);
    }
  };

  useEffect(() => {
    setVersionIndex(0);
  }, []);

  return versionIndex !== null ? (
    <OptimizelyPaywall
      allowClose={false}
      authMode={authMode}
      isMobile={showMobile}
      nextUrl={nextUrl}
      placement={placement}
      setShowPaywall={closePaywall}
    />
  ) : null;
});

SophiIterations.displayName = 'SophiIterations';
